import COLORS from '@/constants/colors';

export default {
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: COLORS.gray_600,
    m: 0,
    p: 0,
  },
  close: { right: '-12px' },
};
